import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {CardModule} from 'primeng/card';
import {BadgeModule} from 'primeng/badge';
import {TreeTableModule} from 'primeng/treetable';
import {DataViewModule} from 'primeng/dataview';
import {ButtonModule} from 'primeng/button';
import {TooltipModule} from 'primeng/tooltip';
import {DialogModule} from 'primeng/dialog';
import {ProgressSpinnerModule} from 'primeng/progressspinner';
import {InputTextModule} from 'primeng/inputtext';
import {DropdownModule} from 'primeng/dropdown';
import {FormsModule} from '@angular/forms';
import {InputNumberModule} from 'primeng/inputnumber';
import {InputMaskModule} from 'primeng/inputmask';
import {TableModule} from 'primeng/table';
import {StepsModule} from 'primeng/steps';
import {InputTextareaModule} from 'primeng/inputtextarea';
import {CheckboxModule} from 'primeng/checkbox';
import {MultiSelectModule} from 'primeng/multiselect';
import {TabViewModule} from 'primeng/tabview';
import {FileUploadModule} from 'primeng/fileupload';
import {OverlayPanelModule} from 'primeng/overlaypanel';
import {SidebarModule} from 'primeng/sidebar';
import {MessagesModule} from 'primeng/messages';
import {MessageModule} from 'primeng/message';
import {ToastModule} from 'primeng/toast';
import {TabMenuModule} from 'primeng/tabmenu';
import {TimelineModule} from 'primeng/timeline';
import {DockModule} from 'primeng/dock';
import {ScrollerModule} from 'primeng/scroller';
import {VirtualScrollerModule} from 'primeng/virtualscroller';
import {AnimateModule} from 'primeng/animate';
import {ConfirmDialogModule} from 'primeng/confirmdialog';
import {TagModule} from 'primeng/tag';
import {PanelMenuModule} from 'primeng/panelmenu';
import {CalendarModule} from 'primeng/calendar';
import {AvatarModule} from 'primeng/avatar';
import {ImageModule} from 'primeng/image';
import {PaginatorModule} from 'primeng/paginator';
import {CarouselModule} from 'primeng/carousel';
import {ChartModule} from 'primeng/chart';
import {SpeedDialModule} from 'primeng/speeddial';
import {AccordionModule} from 'primeng/accordion';
import {PanelModule} from 'primeng/panel';
import {DividerModule} from 'primeng/divider';
import {MegaMenuModule} from 'primeng/megamenu';
import {MenubarModule} from 'primeng/menubar';
import {ScrollTopModule} from 'primeng/scrolltop';
import {GalleriaModule} from 'primeng/galleria';

@NgModule({
    declarations: [],
    imports: [
        CommonModule
    ],
    exports: [
        GalleriaModule,
        ScrollTopModule,
        CardModule,
        BadgeModule,
        TreeTableModule,
        DataViewModule,
        ButtonModule,
        TooltipModule,
        DialogModule,
        ProgressSpinnerModule,
        InputTextModule,
        DropdownModule,
        FormsModule,
        InputNumberModule,
        InputMaskModule,
        TableModule,
        StepsModule,
        InputTextareaModule,
        CheckboxModule,
        MultiSelectModule,
        TabViewModule,
        FileUploadModule,
        OverlayPanelModule,
        SidebarModule,
        MessageModule,
        MessagesModule,
        ToastModule,
        TabMenuModule,
        TimelineModule,
        DockModule,
        ScrollerModule,
        VirtualScrollerModule,
        AnimateModule,
        ConfirmDialogModule,
        TagModule,
        PanelMenuModule,
        CalendarModule,
        AvatarModule,
        ImageModule,
        PaginatorModule,
        CarouselModule,
        ChartModule,
        SpeedDialModule,
        AccordionModule,
        PanelModule,
        DividerModule,
        MegaMenuModule,
        MenubarModule,
        MessagesModule
    ]
})
export class PrimeNgModule {
}
